const SNILS_LENGTH = 11;

export type SnilsStepValues = {
	snils: string;
};

export const EMPTY_SNILS: SnilsStepValues = {
	snils: '',
};

export const extractSnilsDigits = (value: string): string => {
	return value.replace(/\D/g, '').slice(0, SNILS_LENGTH);
};

export const hasSavedSnils = (snils: string | null | undefined): boolean => {
	return extractSnilsDigits(snils ?? '').length === SNILS_LENGTH;
};

/** СНИЛС из GET /identification/info, если он уже полный. */
export const readSavedSnilsDigits = (info: unknown): string | null => {
	if (!info || typeof info !== 'object' || !('snils' in info)) {
		return null;
	}

	const snils = (info as {snils?: unknown}).snils;

	if (typeof snils !== 'string' || !hasSavedSnils(snils)) {
		return null;
	}

	return extractSnilsDigits(snils);
};

export const isSnilsStepValid = (values: SnilsStepValues): boolean => {
	return values.snils.length === SNILS_LENGTH;
};

export const isSnilsStepValidForRequirement = (
	requirement: 'hidden' | 'optional' | 'mandatory',
	values: SnilsStepValues,
): boolean => {
	if (requirement === 'hidden') {
		return true;
	}

	if (requirement === 'optional' && !values.snils.length) {
		return true;
	}

	return isSnilsStepValid(values);
};

export const buildSnilsRequest = (values: SnilsStepValues): {snils: string} | null => {
	if (!isSnilsStepValid(values)) {
		return null;
	}

	return {snils: values.snils};
};
